import type { RootState } from 'state';

function getCoverageAmountSuppliers(state: RootState): string[] {
  const { value } = state.bookings.coverageAmountSuppliers;

  if (!value) {
    return [];
  }

  return value;
}

export default getCoverageAmountSuppliers;
